import React from "react"
import { Modal, Descriptions, Button } from "antd"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"
import { deleteImages } from "services/main.js"
import moment from "moment"

const UserInfoModal = ({
  isModalOpen,
  setIsModalOpen,
  userDetail,
  userPhotos,
  setUserPhotos,
  setUserDetail,
  getUserByUserId,
  getUsers,
}) => {
  const handleRemoveImages = () => {
    deleteImages(parseInt(userDetail?.account?.id), () => {
      getUserByUserId(userDetail.id)
      getUsers(null, null, 25, 1)
    })
  }

  const openImageInNewTab = (imageUrl) => {
 
    const newWindow = window.open();
    
 
    const imgElement = newWindow.document.createElement('img');
    
    
    imgElement.src = imageUrl;
    

    imgElement.style.maxWidth = '100%';
    imgElement.style.maxHeight = '100%';
    imgElement.style.objectFit = 'contain';
    
    
    newWindow.document.body.appendChild(imgElement);
  };

  return (
    <Modal
      title="Dettagli Utente"
      visible={isModalOpen}
      onCancel={() => {
        setIsModalOpen(false)
        setUserPhotos({})
        setUserDetail({})
      }}
      footer={null}
    >
      {userDetail && (
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Nome Completo">{`${userDetail.first_name} ${userDetail.last_name}`}</Descriptions.Item>
          <Descriptions.Item label="Username">
            {userDetail.username}
          </Descriptions.Item>
          <Descriptions.Item label="Email">{userDetail.email}</Descriptions.Item>
          <Descriptions.Item label="Telefono">{userDetail.phone}</Descriptions.Item>
          <Descriptions.Item label="Indirizzo">{`${userDetail.address}, ${userDetail.city}, ${userDetail.cap}, ${userDetail.country}`}</Descriptions.Item>
          <Descriptions.Item label="Codice Comune">
            {userDetail.comune_code}
          </Descriptions.Item>
          <Descriptions.Item label="Codice Fiscale">
            {userDetail.personal_number}
          </Descriptions.Item>
          <Descriptions.Item label="Luogo di Nascita">
            {`${userDetail.birth_place}, ${userDetail.birth_comune_code}, ${
              userDetail.birth_country
            } (${moment(userDetail?.birthday).format("DD/MM/YYYY")})`}
          </Descriptions.Item>
          <Descriptions.Item label="Numero Documento">
            {userDetail.document_number}
          </Descriptions.Item>
          <Descriptions.Item label="Data di Rilascio">
            {userDetail.data_di_rilascio}
          </Descriptions.Item>
          <Descriptions.Item label="Data di Scadenza">
            {userDetail.data_di_scadenza}
          </Descriptions.Item>

          <Descriptions.Item label="Documenti">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",

                alignItems: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                {userDetail.document_front && userPhotos?.front ? (
                  <>
                    <img
                      src={userPhotos.front}
                      alt="Front Document"
                      width={120}
                      style={{
                        borderRadius: "5px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => openImageInNewTab(userPhotos.front)}
                    />

                    <div style={{ marginTop: "5px", fontWeight: "bold" }}>Front</div>
                  </>
                ) : (
                  <span style={{ color: "#999" }}>Front Image Not Available</span>
                )}
              </div>

              <div style={{ textAlign: "center" }}>
                {userDetail.document_back && userPhotos?.back ? (
                  <>
                    <img
                      src={userPhotos.back}
                      alt="Back Document"
                      width={120}
                      style={{
                        borderRadius: "5px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => openImageInNewTab(userPhotos.back)}
                    />

                    <div style={{ marginTop: "5px", fontWeight: "bold" }}>Back</div>
                  </>
                ) : (
                  <span style={{ color: "#999" }}>Back Image Not Available</span>
                )}
              </div>
            </div>

            {(userPhotos?.front || userPhotos?.back) && (
              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <Button
                  type="primary"
                  danger
                  onClick={handleRemoveImages}
                  style={{ background: "red", borderColor: "red" }}
                >
                  Remove Images
                </Button>
              </div>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Ruolo">{userDetail.role}</Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  userDetail: state.auth.userDetail,
  userPhotos: state.main.userPhotos,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  UserInfoModal
)
